import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MigrationsMainComponent } from './containers/migrations-main/migrations-main.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { MigrationsAccountDetailComponent } from './containers/migrations-account-detail/migrations-account-detail.component';
import {
  MIGRATIONS_FEATURE_KEY,
  reducer as migrationsReducer,
  initialState as migrationsInitialState,
} from './state/migrations.reducer';
import { MigrationsEffects } from './state/migrations.effects';
import { MigrationsAccountComponent } from './components/migrations-account/migrations-account.component';
import { MigrationsChartsComponent } from './components/migrations-charts/migrations-charts.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MigrationDetailModalComponent } from './components/migration-detail-modal/migration-detail-modal.component';
import { MigrationsStateFilterComponent } from './components/migrations-state-filter/migrations-state-filter.component';
import { MigrationsLastProgressComponent } from './components/migrations-last-progress/migrations-last-progress.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    NgbModule,
    ReactiveFormsModule,
    StoreModule.forFeature(MIGRATIONS_FEATURE_KEY, migrationsReducer, {
      initialState: migrationsInitialState,
    }),
    EffectsModule.forFeature([MigrationsEffects]),
  ],
  declarations: [
    MigrationsMainComponent,
    MigrationsAccountDetailComponent,
    MigrationsAccountComponent,
    MigrationsChartsComponent,
    MigrationDetailModalComponent,
    MigrationsStateFilterComponent,
    MigrationsLastProgressComponent,
  ],
})
export class MigrationsModule {}
